export default function addTravelataClassTheme() {
    document.querySelector('body')?.setAttribute('data-travelata-theme', 'light');
  }